import { ComponentProps } from 'react';

export function BrandsGoogle({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.5 15.8625C30.5 24.7062 24.4438 31 15.5 31C6.925 31 0 24.075 0 15.5C0 6.925 6.925 0 15.5 0C19.675 0 23.1875 1.53125 25.8937 4.05625L21.675 8.1125C16.1562 2.7875 5.89375 6.7875 5.89375 15.5C5.89375 20.9062 10.2125 25.2875 15.5 25.2875C21.6375 25.2875 23.9375 20.8875 24.3 18.6063H15.5V13.275H30.2563C30.4 14.0687 30.5 14.8312 30.5 15.8625Z"
        fill="currentColor"
      />
    </svg>
  );
}
